import { render, staticRenderFns } from "./SubheaderCard.vue?vue&type=template&id=5e2694ec&scoped=true&"
import script from "./SubheaderCard.vue?vue&type=script&lang=js&"
export * from "./SubheaderCard.vue?vue&type=script&lang=js&"
import style0 from "./SubheaderCard.vue?vue&type=style&index=0&id=5e2694ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2694ec",
  null
  
)

export default component.exports